import { $, pageData } from '../lib/dom.js';
import { ct } from '../lib/i18n.js';
import { api } from '../lib/api.js';
import { trackDirtyForm } from '../lib/dirty-form.js';
import { findSelectMenu } from '../lib/select-menu.js';

/**
 * The Reminders page.
 *
 * The bump's counters are read from the server and never sent back: they are
 * the state of something happening, and a page from ten minutes ago must not be
 * able to make the bot forget a bump it has already seen.
 */

interface Settings {
  watchwords: { enabled: boolean; maxWords: number; cooldownSeconds: number };
  bump: { enabled: boolean; channelId: string; roleId: string; total: number };
}

export function initNudgesPage(): void {
  const form = $<HTMLFormElement>('[data-nudges-form]');
  if (!form) return;

  const { settings, guildId } = pageData<{ settings: Settings; guildId: string }>();

  trackDirtyForm({
    form,
    successMessage: ct('settingsSaved', 'Settings saved.'),
    onSave: async () => {
      await api.put(`/api/nudges?guildId=${guildId}`, {
        guildId,
        watchwords: {
          enabled: checkbox(form, 'wordsEnabled'),
          maxWords: number(form, 'maxWords', 5),
          cooldownSeconds: number(form, 'cooldownSeconds', 300),
        },
        bump: {
          enabled: checkbox(form, 'bumpEnabled'),
          channelId: findSelectMenu(form, 'bumpChannelId')?.single ?? '',
          roleId: findSelectMenu(form, 'bumpRoleId')?.single ?? '',
        },
      });
    },
  });

  const channel = findSelectMenu(form, 'bumpChannelId');
  if (channel) channel.value = settings.bump.channelId ? [settings.bump.channelId] : [];

  const role = findSelectMenu(form, 'bumpRoleId');
  if (role) role.value = settings.bump.roleId ? [settings.bump.roleId] : [];
}

function number(form: HTMLFormElement, name: string, fallback: number): number {
  const field = form.elements.namedItem(name);
  return field instanceof HTMLInputElement ? Number(field.value) || fallback : fallback;
}

function checkbox(form: HTMLFormElement, name: string): boolean {
  const field = form.elements.namedItem(name);
  return field instanceof HTMLInputElement ? field.checked : false;
}
